import HeadTittle from '../../../../../components/HeadTittle';
import UpdateEquipmentMaterialApp from '../Functionality/UpdateEquipmentMaterialApp';
import routes from '../../../../../Routes/routes';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { EditIcon } from '../../../../../components/buttons/IconButtons';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { STEPS_EQUIPMENT_AND_MATERIAL } from '../Model/Model';
import TechnicalDetails from './TechnicalDetails';
import GeneralDetailsStep from './GeneralDetailsStep';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { SUGGESTION_MODE_OPTION } from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UpdateEquipmentMaterial = () => {
    const {
        t,
        id,
        handleUpdate,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        item,
        disabled,
        handleChange,
        emptyFields,
        photoPickerFile,
        setPhotoPickerFile,
        categoryOptions,
        setCategoryOptions,
        subCategoryOptions,
        setSubCategoryOptions,
        selectedCategory,
        setSelectedCategory,
        selectedSubCategory,
        setSelectedSubCategory,
        dispatch,
        createSubcategoryBody,
        createCategoryBody,
        handleCreateSubcategoryCategory,
        handleSearchSubcategory,
        handleSearchCategory,
    } = UpdateEquipmentMaterialApp();

    return (
        <>
            <HeadTittle name={'update'} link={routes.equipmentAndMaterial.list}>
                <ButtonAction
                    id='btn_uem_update_equipment_and_material'
                    name={'update'}
                    Icon={EditIcon}
                    className='btn-icon-edit'
                    onClick={handleUpdate}
                />
            </HeadTittle>
            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab
                    index={STEPS_EQUIPMENT_AND_MATERIAL.GENERAL_DETAILS.INDEX}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {activeStep === STEPS_EQUIPMENT_AND_MATERIAL.GENERAL_DETAILS.INDEX && (
                        <GeneralDetailsStep
                            t={t}
                            item={item}
                            id={id}
                            disabled={disabled}
                            emptyFields={emptyFields}
                            handleChange={handleChange}
                            categoryOptions={categoryOptions}
                            setCategoryOptions={setCategoryOptions}
                            subCategoryOptions={subCategoryOptions}
                            setSubCategoryOptions={setSubCategoryOptions}
                            selectedCategory={selectedCategory}
                            setSelectedCategory={setSelectedCategory}
                            selectedSubCategory={selectedSubCategory}
                            setSelectedSubCategory={setSelectedSubCategory}
                            dispatch={dispatch}
                            createSubcategoryBody={createSubcategoryBody}
                            createCategoryBody={createCategoryBody}
                            handleCreate={handleCreateSubcategoryCategory}
                            handleSearchSubcategory={handleSearchSubcategory}
                            handleSearchCategory={handleSearchCategory}
                        />
                    )}
                </StepTab>
                <StepTab
                    index={STEPS_EQUIPMENT_AND_MATERIAL.TECHNICAL_DETAILS.INDEX}
                    activeStep={activeStep}
                    normalHeight={true}
                >
                    {activeStep && activeStep === STEPS_EQUIPMENT_AND_MATERIAL.TECHNICAL_DETAILS.INDEX && (
                        <TechnicalDetails
                            t={t}
                            item={item}
                            disabled={disabled}
                            emptyFields={emptyFields}
                            handleChange={handleChange}
                        />
                    )}
                </StepTab>
                <StepTab index={STEPS_EQUIPMENT_AND_MATERIAL.PHOTO.INDEX} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_EQUIPMENT_AND_MATERIAL.PHOTO.INDEX && (
                        <CustomPhotoPicker
                            id='fp_uem_update_photo_file'
                            photoPicker={photoPickerFile}
                            setPhotoPicker={setPhotoPickerFile}
                            actionModel={ACTION_MODEL.UPDATE}
                            accept={{ ...FILE_TYPE.IMAGE }}
                            showBtnDelete={true}
                            required={true}
                            disabled={disabled}
                            showBtnCamera={true}
                            validateFace={false}
                            classWith={'content-center-w-400px'}
                            showPreview={true}
                            typeSuggestions={SUGGESTION_MODE_OPTION.MATERIAL_AND_EQUIPMENT}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default UpdateEquipmentMaterial;
